/** Legacy display values. Prefer ActivityTypeKeys for storage and comparison (language-independent). */
export class ActivityTypes {
    static Birthday = 'Birthday';
    static WorkAnniversary = 'Work Anniversary';
    static GoldenJubilee = 'Golden Jubilee';
}
/**
 * Translation keys for ActivityType. Match backend ActivityConstants.ActivityTypeKeys.
 * Use these for comparisons so activities work in any language.
 */
export const ActivityTypeKeys = {
    Birthday: 'ActivityTypes.Birthday',
    WorkAnniversary: 'ActivityTypes.WorkAnniversary',
    WeddingAnniversary: 'ActivityTypes.WeddingAnniversary',
    EmployeeOnboarding: 'ActivityTypes.EmployeeOnboarding',
    CompanyAnniversary: 'ActivityTypes.CompanyAnniversary',
    MarriageAnniversary: 'ActivityTypes.MarriageAnniversary',
    BirthAdoption: 'ActivityTypes.BirthAdoption',
    Retirement: 'ActivityTypes.Retirement',
    RegionalOfficeEntry: 'ActivityTypes.RegionalOfficeEntry',
    EmployeeDeparture: 'ActivityTypes.EmployeeDeparture',
    EmployeeDeath: 'ActivityTypes.EmployeeDeath',
    EmployeeIllness: 'ActivityTypes.EmployeeIllness'
};
/** Activity type codes that represent "anniversary" for calendar/dashboard grouping. */
export const AnniversaryTypeKeys = [
    ActivityTypeKeys.WorkAnniversary,
    ActivityTypeKeys.WeddingAnniversary,
    ActivityTypeKeys.MarriageAnniversary,
    ActivityTypeKeys.CompanyAnniversary
];
export function isBirthdayActivity(activityTypeCode) {
    return activityTypeCode === ActivityTypeKeys.Birthday;
}
export function isAnniversaryActivity(activityTypeCode) {
    return AnniversaryTypeKeys.includes(activityTypeCode);
}
